import React, { useEffect } from "react";
import numeral from "numeral";
import FocusError from "../../../../../components/FocusError";
import {
    Box,
    Button, Checkbox,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    Radio,
    RadioGroup, TextField,
    Tooltip,
    Typography,
} from "@material-ui/core";
import Citizenship from "./ProfileFormFields/Citizenship";
import { ErrorCommon, TextFieldCommon } from "../../../../../components/formikFormInputs";
import { Label } from "../../../../../components/formInputs";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import NumberFormat from "react-number-format";
import InfoIcon from "@material-ui/icons/Info";
import { Formik } from "formik";
import {
    GWT_GEN2_STRATEGY, GWTVersionEnum,
    OTHER_VALUE,
    otherIndustryId,
    REQUIRED_FIELD,
    trustFeeText,
} from "../../../../../constants";
import PersonalIncomeDetailsContent from "./PersonalIncomeDetailsContent";
import IndividualIncome from "./ProfileFormFields/IndividualIncome";
import HouseHoldIncome from "./ProfileFormFields/HouseHoldIncome";
import CurrentEmployeeRadio from "./CurrentEmployeeRadio";
import { isAdmin } from "../../../../../components/navigation/AdminNavigation";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../reducers";
import { isAgent } from "../../../../../utils/commonUtils";
import Socket from "../../../Estimation/V1/Socket";
import { getClientEstimationData, handleButtonClick } from "../../../Estimation/V1/Steppers";
import { useActions } from "../../../../../actions";
import * as Actions from "../../../../../actions/estimation";
import NonUSPopUp from "./ProfileFormFields/NonUSPopUp";
import PersonalDetailsDialog from "../component/EnrollmentHome/PersonalDetailsDialog";
import ParentsAreIncomeEarner from "./ProfileFormFields/ParentsAreIncomeEarner";
import PoliticalRelationFields, { politicalRelationsInitValue } from "./ProfileFormFields/PoliticalRelations";
import GreenCardAndVisaExpiry from "../../EnrollmentHome/basicInfo/GreenCardAndVisaExpiry";

type PropsType = {
	initialValues: any,
	personalDetailSchema: any,
	isCorporation: boolean,
	setOpenKickOutPopup: Function,
	setIsFormSubmit: Function,
	isFromClientDetail: boolean | undefined,
	proofExpired: any,
	isNationalLife: boolean,
	selfEmployed: boolean,
	minAge: any,
	setInitialValues: Function,
	setNextStep: Function,
	client: any,
	setActionItem: Function,
	role: any,
	setIsPersonalFormDirty: Function | undefined,
	setIsFormSubmitting: Function | undefined,
	setIncomeAlertOpen: Function,
	setValidationError: Function | undefined,
	setSelfEmployed: Function,
	accountActions: any,
	setOpenAlert: Function,
	user: any,
	fieldObj: any,
	clientSigned: boolean | number,
	conditionalRequired: boolean,
	setCurrentlyEmployed: Function,
	setFullTimeEmployee: Function
	fullTimeEmployee: any,
	CommonField: Function,
	classes: any,
	fieldObj1: any,
	fieldObj8: any,
	proofExpireRef: any,
	fieldObj4: any,
	fieldObj7: any,
	fieldObj9: any,
	fieldObj2: any,
	fieldObj3: any,
	fieldObj14: any,
	strategySlug: string,
	fieldObj6: any,
	clientDetail: any,
	showClientContribution: boolean,
	showEmployerContribution: boolean,
	minVal: any,
	personalDetailSubmit: any,
	setFullTimeSelected: Function,
	fullTimeSelected: number,
	setIsDocumentAddress?: Function,
	setIsMarried: Function,
	setIsEmployed: Function,
	isAllianzLife: boolean,
	setIsParentEarner: Function,
	isParentEarner: boolean,
	personalDetailForm?: any,
	makePersonalDetailPayload?: Function,
	sendSaveRequest: Function,
	getClientDetail?: Function,
	urlClientId?: string,
	ssnFlag?: boolean,
	setServerError: Function,
	serverError: boolean
	setAnticipatedAge: Function,
	currentlyEmployed: string,
    saveMe?: Function,
	greenCardExpiryFieldObj: any,
    visaExpiryFieldObj: any
}
export const incomeDetailsColArr = [
	"indIncomeLastYearAnnualSalary", "indIncomeLastYearDividends",
	"indIncomeLastYearOtherIncome",
	"indIncomeLastYearTotal",

	"indIncome1YearsPriorAnnualSalary",
	"indIncome1YearsPriorDividends",
	"indIncome1YearsPriorOtherIncome",
	"indIncome1YearsPriorTotal",

	"indIncome2YearsPriorAnnualSalary",
	"indIncome2YearsPriorDividends",
	"indIncome2YearsPriorOtherIncome",
	"indIncome2YearsPriorTotal",

	"houseHoldIncomeLastYearAnnualSalary",
	"houseHoldIncomeLastYearDividends",
	"houseHoldIncomeLastYearOtherIncome",
	"houseHoldIncomeLastYearTotal",

	"houseHoldIncome1YearsPriorAnnualSalary",
	"houseHoldIncome1YearsPriorDividends",
	"houseHoldIncome1YearsPriorOtherIncome",
	"houseHoldIncome1YearsPriorTotal",

	"houseHoldIncome2YearsPriorAnnualSalary",
	"houseHoldIncome2YearsPriorDividends",
	"houseHoldIncome2YearsPriorOtherIncome",
	"houseHoldIncome2YearsPriorTotal"];

	const desc = [
		{type:"text", text: "1. Immediate relative is defined as a spouse/partner, children, children’s spouse/partner, or parents."},
		{type:"text", text: "2. Close associate is defined as close friend, contractual business associate, legal advisor, sole owner of a business in which you benefit, or connected relationship through a trust. "},
		{type:"subHeading", text:"Roles:"},
		{type:"text", text:"Heads of state government (e.g. president, chief of staff, etc.)"},
		{type:"text", text:"Legislative official (e.g. senator, congress person, etc.)"},
		{type:"text", text:"Federal government official (e.g. public administration, officer, department of defense officials, appointed officials, etc.)"},
		{type:"text", text:"State/ city/ county government role (e.g. appointed officials, governor, mayor, etc.)"},
		{type:"text", text:"Judicial roles in the supreme/ federal/ state court systerms (e.g. judge, district attorney, etc.)"},
		{type:"text", text:"Political party officials (e.g. party leader, campaign manager, treasurer, etc.)"}
	]
let touchedState: any = {}
function PersonalDetailFormikContent(props: PropsType) {
	const {
		initialValues,
		personalDetailSchema,
		isCorporation,
		isFromClientDetail,
		proofExpired,
		minAge,
		setNextStep,
		client,
		setActionItem,
		role,
		setIsPersonalFormDirty,
		setSelfEmployed,
		setFullTimeEmployee,
		fullTimeEmployee,
		showClientContribution,
		setIsFormSubmitting,
		showEmployerContribution,
		setIncomeAlertOpen,
		setValidationError,
		accountActions,
		user,
		minVal,
		personalDetailSubmit,
		fieldObj,
		clientSigned,
		conditionalRequired,
		CommonField,
		fieldObj1,
		fieldObj8,
		fieldObj4,
		proofExpireRef,
		fieldObj7,
		fieldObj9,
		fieldObj14,
		classes,
		fieldObj2,
		setCurrentlyEmployed,
		strategySlug,
		fieldObj3,
		fieldObj6,
		setFullTimeSelected,
		fullTimeSelected,
		setIsDocumentAddress,
		setIsMarried,
		setIsEmployed,
		isAllianzLife,
		setIsParentEarner,
		isParentEarner,
		isNationalLife,
		personalDetailForm,
		makePersonalDetailPayload,
		sendSaveRequest,
		getClientDetail,
		urlClientId,
		ssnFlag,
		setServerError,
		serverError,
		setAnticipatedAge,
        contributionAmount,
        setBasicInfoStep,
		currentlyEmployed,
        saveMe,
		greenCardExpiryFieldObj,
        visaExpiryFieldObj

	}: any = props;
	const authUser = useSelector((state: RootState) => state.auth.user);
	const id = user && user.client && user.client.userId;
	const clientPolicy = user && user.client && user.client.clientPolicies.length > 0 && user.client.clientPolicies[0];
	const callingFrom: string = "ENROLLMENT_TAB";
	const estimationActions = useActions(Actions);
	const [showResults, setShowResults] = React.useState<boolean>(false);
	const [isEstimationDataLoading, setIsEstimationDataLoading] = React.useState<boolean>(false);
	const [requestId, setRequestId] = React.useState<null | string>(null);
	const [responseData, setResponseData] = React.useState<any>("");
	const [lifeTimeDeathBenefitSeeking, setLifeDeathBenefitSeeking] = React.useState(false);
	const [isReportRequestCompleted, setIsReportRequestCompleted] = React.useState<boolean>(false);
	const [isReportRequestAutomated, setIsReportRequestAutomated] = React.useState<boolean>(false);
	const [isReportDataLoading, setIsReportDataLoading] = React.useState<boolean>(false);
    const [nonUSPopUp, setNonUSPopUp] = React.useState<boolean>(false);
    const [openPersonalDialog, SetOpenPersonalDialog] = React.useState(false);
    const [dobCheck, setDobCheck] = React.useState<boolean>(false);
    const financiallyDependent: boolean = clientPolicy && clientPolicy.financiallyDependent;
    const isGWTGenV2 = (user && user.client && user.client.gwtVersion === GWTVersionEnum.Two);
    const gwtV2FD = isGWTGenV2 ? !financiallyDependent : true;
    const [incomeEarner, setIncomeEarner] = React.useState<boolean>(true); //!!(clientPolicy && clientPolicy.qualifiedIncomeEarner === 1)
    const disabled: boolean = !!(clientSigned || !isGWTGenV2);
    const errors = personalDetailForm.current &&  personalDetailForm.current.errors
    // we are handling touched in state because onsubmit formik by default show all fields in touched
    const [touchedCustom, setTouchedCustom] = React.useState({});
	const userObj = {
		id, role,
	};
	const handleResult = () => {
		setShowResults(true);
		setIsEstimationDataLoading(false);
	};

	const handleReset = () => {
		localStorage.removeItem("success");
		localStorage.removeItem("lastEstimatedTime");
		localStorage.removeItem("lifeDeathBenefitSeeking");
		setShowResults(false);
	};
	useEffect(() => {
		if (user && user.client && user.client.userId) {
			getClientEstimationData({
				estimationActions,
				userId: user.client.userId,
				setResponseData,
				setLifeDeathBenefitSeeking,
				handleResult,
				handleReset,
				callingFrom,
                clientPolicyId: clientPolicy && clientPolicy.id,
			}).then(() => {
			});
		}
	}, []);

	const basicInfoQuestions = () => {
		return [
			{
				name: "USBasedCompany",
				heading: "Is your company a U.S. based company?"
			},
            // {
            //     name: "highRanking",
            //     heading: "Entrusted with a high-ranking prominent political function?"
            // },
			{
				name: "highRanking",
				heading: "Do you or have you or any immediate relatives or close associates held any of the roles listed below (or the equivalent if role was held someplace other than the United States)? ",
                onSelectChange: (ev: any, value: any) => {
                    if(value == 0) {
                        personalDetailForm && personalDetailForm.current && personalDetailForm.current.setFieldValue("politicalRelations",[])
                    }else{
                        personalDetailForm && personalDetailForm.current && personalDetailForm.current.setFieldValue("politicalRelations",[politicalRelationsInitValue])
                    }
                },
                subHeading:
				<Grid className="mt15">
					{desc.map(t=>(
							t.type === "text" ? <Typography className="mt5 textLight" variant="body2">{t.text}</Typography> : <Typography className="mt15 textLight" variant="subtitle1">{t.text}</Typography>
					))}
				</Grid>,
                subField: <>
                    {!!(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["politicalRelations"] && personalDetailForm.current.values["politicalRelations"].length > 0) &&
                    <Grid item xs={12} md={12} className="mt15">
                        <Typography variant="caption" className="floatLeft mt20 mb20"> <Label
                                label={"Please provide the following information for all the roles held by you or a relative or close associate within the past 12 month"}
                                /> </Typography>
                        <PoliticalRelationFields />
                    </Grid>}
                </>
			},

			{
				name: "workInIndustries",
				heading: "Do you operate or work in following industries?",
				subHeading: "Oil, gas, crypto currency, gambling, weapons, precious metals, minerals or precious stones, tobacco, cannabis, marijuana products, cultural goods or other articles of archeological, historical, cultural or religious importance of exceptional scientific value, including ivory and protected species.",
                subField: {
					id:"workIndDesc",
					name:"workIndDesc",
					text:"Please provide a detailed description of the nature of business and the industry:",
					isRequired: true,
                	component: TextField,
                	variant: "outlined",
					show: !!(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["workInIndustries"]),
					multiline: true,
                	rows: 2,
				}
			},
		];
	};

    const radioToggleButtonError = (filedName: string, currentlyEmployed: string, valuesFiledName: any, buttonsPair: boolean) => {
        const errorHelperStyle: React.CSSProperties = { color: "#FF1744", fontSize: "10px", margin: "0" };
        let error = false;

        if ((valuesFiledName === "" || valuesFiledName === null) && !isGWTGenV2) {
            error = true;
        }

        if (buttonsPair && (currentlyEmployed === "HOME_MAKER" || currentlyEmployed === "STUDENT" || currentlyEmployed === OTHER_VALUE)) {
            error = false;
        }

        if (isGWTGenV2 && !financiallyDependent && (currentlyEmployed === "FULL_TIME" || currentlyEmployed === "PART_TIME" || currentlyEmployed === "SELF_EMPLOYED") && (valuesFiledName === "" || valuesFiledName === null)) {
            error = true;
        } else if (isGWTGenV2 && financiallyDependent){
            error = false;
        }

        return (
                <>
                    {
                            (error) &&
                            <Grid item xs={12}>
                                <FormHelperText style={errorHelperStyle}>
                                    <span className="w100 floatLeft"> {REQUIRED_FIELD} </span>
                                </FormHelperText>
                            </Grid>
                    }
                </>
        );
    };
    const documentDetailsDiscrepancyQuestions = [
        {
            name: "isDocumentAddress",
            label: "Is this the home address displayed on your driver’s license?",
            helperText : !(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["isDocumentAddress"]) && !isFromClientDetail &&
                    <span className="f12 colorRed floatLeft w100 mt15 mb15">You will be required to upload utility docs to confirm your address.</span>,
            onChange : (e: any, val: any)=>{
                if (typeof setIsDocumentAddress === "function")
                    setIsDocumentAddress(val);
                // on true remove subfield
                if(val){
                    personalDetailForm && personalDetailForm.current && personalDetailForm.current.setFieldValue("addressDiscrepancyDescription", "");
                }
                personalDetailForm && personalDetailForm.current && personalDetailForm.current.setFieldValue("isDocumentAddress", !personalDetailForm.current.values["isDocumentAddress"]);
                sendSaveRequest(Math.random());
            },
            value:personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["isDocumentAddress"],
            options: [
                {
                    label: "Yes",
                    value: true,
                    active : (personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["isDocumentAddress"])
                },
                {
                    label: "No",
                    value: false,
                    active :  !(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["isDocumentAddress"])
                },
            ],
            subfield:{
                id: "addressDiscrepancyDescription",
                name: "addressDiscrepancyDescription",
                label: <Label label={"If your home address does not match your upload document, explain why below."} required={true} />,
                isRequired: true,
                component: TextField,
                variant: "outlined",
                show: !(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["isDocumentAddress"]),
                multiline: true,
                rows: 2,
            },
        },
        {
            name: "dobMatchOnDocument",
            label: "Does your date of birth match the one on your identity document?",
            helperText : <></>,
            onChange : (e: any, val: any)=>{
                if (typeof setIsDocumentAddress === "function")
                    setIsDocumentAddress(val);
                // on true remove subfield
                if(val){
                    personalDetailForm && personalDetailForm.current && personalDetailForm.current.setFieldValue("dobDiscrepancyDescription", "");
                }
                personalDetailForm && personalDetailForm.current && personalDetailForm.current.setFieldValue("dobMatchOnDocument", val);
                sendSaveRequest(Math.random());
            },
            value:personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["dobMatchOnDocument"],
            options: [
                {
                    label: "Yes",
                    value: true,
                    active : (personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["dobMatchOnDocument"])
                },
                {
                    label: "No",
                    value: false,
                    active :  !(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["dobMatchOnDocument"])
                },
            ],
            subfield:{
                id: "dobDiscrepancyDescription",
                name: "dobDiscrepancyDescription",
                label: <Label label={"If your date of birth does not match your upload document, explain why below."} required={true} />,
                isRequired: true,
                component: TextField,
                variant: "outlined",
                show: !(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["dobMatchOnDocument"]),
                multiline: true,
                rows: 2,
            },
        },
        {
            name: "nameMatchOnDocument",
            label: "Does your name match the one on your identity document?",
            helperText : <></>,
            onChange : (e: any, val: any)=>{
                if (typeof setIsDocumentAddress === "function")
                    setIsDocumentAddress(val);
                // on true remove subfield
                if(val){
                    personalDetailForm && personalDetailForm.current && personalDetailForm.current.setFieldValue("nameDiscrepancyDescription", "");
                }
                personalDetailForm && personalDetailForm.current && personalDetailForm.current.setFieldValue("nameMatchOnDocument", val);
                sendSaveRequest(Math.random());
            },
            value:personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["nameMatchOnDocument"],
            options: [
                {
                    label: "Yes",
                    value: true,
                    active : (personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["nameMatchOnDocument"])
                },
                {
                    label: "No",
                    value: false,
                    active :  !(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["nameMatchOnDocument"])
                },
            ],
            subfield:{
                id: "nameDiscrepancyDescription",
                name: "nameDiscrepancyDescription",
                label: <Label label={"If your name does not match your upload document, explain why below."} required={true} />,
                isRequired: true,
                component: TextField,
                variant: "outlined",
                show: !(personalDetailForm && personalDetailForm.current && personalDetailForm.current.values["nameMatchOnDocument"]),
                multiline: true,
                rows: 2,
            },
        },
    ]

    const radioToggleButtonClassName = (filedName: string, values: string, status: any) => {
        let className: string = '';
        if ((filedName !== "USBasedCompany") && (values[filedName] === status)) {
            className = "active";
        } else if ((filedName !== "workInIndustries") && (values[filedName] === status)) {
            className = "active";
        } else if ((filedName === "USBasedCompany" || filedName === "workInIndustries") && (values[filedName] === status) && (values["currentlyEmployed"] !== "HOME_MAKER" || values["currentlyEmployed"] !== "STUDENT" || values["currentlyEmployed"] !== OTHER_VALUE)){
            className = "active";
        }
        return className;
    };
	const radioToggleButtonGroup = (filedName: string, values: any, setFieldValue: Function, heading: string, subHeading?: string, subField?: any, onSelectChange?: Function) => {
        const buttonsPair: boolean = filedName === "USBasedCompany" || filedName === "workInIndustries";
        const disableFor: boolean = values["currentlyEmployed"] === "HOME_MAKER" || values["currentlyEmployed"] === "STUDENT" || values["currentlyEmployed"] === OTHER_VALUE;
        const requiredConditional = isGWTGenV2 ? (gwtV2FD ? (values["currentlyEmployed"] === "FULL_TIME" || values["currentlyEmployed"] === "PART_TIME" || values["currentlyEmployed"] === "SELF_EMPLOYED") : false) : (buttonsPair && disableFor ? false : conditionalRequired);
        const currentForm = personalDetailForm.current
        return (
			<>
				<Grid item xs={12} sm={12} md={9}>
                    <Typography variant="caption" className="floatLeft mt20 w100"> <Label
                            label={heading}
                            required={requiredConditional} />
                    </Typography>
					{subHeading &&
						<>
							<Grid container>
								<Grid item xs={12}>
									<span className="f12 textLight">{subHeading}</span>
								</Grid>
							</Grid>
						</>
					}
				</Grid>
                <Grid item xs={12} sm={12} md={3}>
                    <Grid container>
                        <Grid item xs={12}>
                            <ToggleButtonGroup
                                    className="toggleButtonGroupQust floatRight"
                                    size="medium"
                                    color={"primary"}
                                    exclusive
                                    id={filedName}
                                    value={values[filedName] === "" ? "" : values[filedName] === 1 ? 1 : values[filedName] === 0 ? 0 : ""}
                                    onChange={(ev: any, value: any) => {
										onSelectChange && onSelectChange(ev, value)
										if(value !== null) {
											if (value === 1) {
                                            setFieldValue(filedName, value);
                                        }
                                        if (value === 0) {
                                            setFieldValue(filedName, value);
                                        }
										}
                                        sendSaveRequest(Math.random());
                                    }}
                            >
                                <ToggleButton value={1}
                                              disabled={!!clientSigned || (buttonsPair && disableFor)}
                                              className={radioToggleButtonClassName(filedName, values, 1)}>
                                    Yes
                                </ToggleButton>
                                <ToggleButton value={0}
                                              disabled={!!clientSigned || (buttonsPair && disableFor)}
                                              className={radioToggleButtonClassName(filedName, values, 0)}>
                                    No
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
						<Grid item xs={12}>
                            <span className="floatRight">
                                {
                                    radioToggleButtonError(filedName, values["currentlyEmployed"], values[filedName], buttonsPair)
                                }
                            </span>
						</Grid>
					</Grid>
				</Grid>
                {
                    (React.isValidElement(subField) ? subField :
                    (subField && subField.show) &&
                        <Grid item xs={12} md={12} className="mt15">
                            <Typography>{subField && subField.text}</Typography>
                            {<TextFieldCommon
                                    {...subField}
                                    values={values}
                                    value={values["workIndDesc"]}
                                    onChange={currentForm && currentForm.handleChange}
                            />}
                            <ErrorCommon
                                    errors={currentForm && currentForm.errors}
                                    name={subField.name}
                                    touched={currentForm && currentForm.touched}
                            />
                        </Grid>)
                }
			</>
		);
	};


	return (
		<>
			<div>
				<Socket
					handleResult={handleResult}
					setIsEstimationDataLoading={setIsEstimationDataLoading}
					setResponseData={setResponseData}
					handleReset={handleReset}
					userId={id}
					page={"clientDetails"}
					setIsReportRequestCompleted={setIsReportRequestCompleted}
					setLifeDeathBenefitSeeking={() => {
					}}
					isReportRequestAutomated={isReportRequestAutomated}
					handleButtonClick={(loader) => handleButtonClick({
						loader,
						user: userObj,
						setIsEstimationDataLoading,
						setIsReportRequestAutomated,
						setRequestId,
						setIsReportRequestCompleted,
						estimationActions,
						setIsReportDataLoading,
						callingFrom,
					})}
					setIsReportDataLoading={setIsReportDataLoading}
					requestId={requestId}
					callingFrom={callingFrom}
				/>
			</div>
			<Formik
				innerRef={personalDetailForm}
				initialValues={initialValues}
				enableReinitialize={true}
				validationSchema={personalDetailSchema}
				validateOnChange={false}
				onSubmit={async (values: any, { setSubmitting, setValues, validateForm }) => {
					await validateForm(values);
					let payload: any = {};
					if (typeof makePersonalDetailPayload === "function") {
						payload = makePersonalDetailPayload(values, setValues, false, touchedState);
					}

					if (!payload) {
						return false;
					}
					try {
						await accountActions.updateUserBasicDetails(payload, (clientPolicy && clientPolicy.id) || 0);
						setTimeout(() => {
							if (!isFromClientDetail) {
								setNextStep();
							} else {
								setActionItem(
									(role == 1 || role == 2 || role == 4) ? true
										:
										(!!(clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.clientSigned && values.usCitizen)),
								);
							}
							setSubmitting(false);
						}, 400);
					} catch (e) {
						if (e && e.message == 422 && (typeof getClientDetail === "function")) {
							getClientDetail(urlClientId || 0, clientPolicy.id, ssnFlag);
							setServerError(true);
						}
						return false;
					}
				}}
			>
				{({
					  values,
					  errors,
					  touched,
					  handleChange,
					  setFieldValue,
					  handleBlur,
					  handleSubmit,
					  isSubmitting,
					  dirty,
                      validateForm,
                      setSubmitting,
                      setTouched,
                      setFieldError
				  }) => {
					if (typeof setIsPersonalFormDirty === "function") {
						setIsPersonalFormDirty(dirty);
					}
					if (typeof setIsFormSubmitting === "function") {
						setIsFormSubmitting(isSubmitting);
					}
					if (Object.keys(errors).length >= 1 && Object.keys(touched).length > 1) {
						let errArr = Object.keys(errors);
						let incomeArr = errArr.filter((item) => {
							if (typeof setIsPersonalFormDirty === "function" && item.indexOf("annualIncome") > -1) {
								setIsPersonalFormDirty(false);
							}
							return item.indexOf("annualIncome") > -1;
						});
						let touchArr = Object.keys(touched);
						let incomeTouchArr = touchArr.filter((item) => {
							return item.indexOf("annualIncome") > -1;
						});
						if (incomeArr.length > 1 && incomeTouchArr.length > 1) {
							setIncomeAlertOpen(true);
						} else {
							setIncomeAlertOpen(false);
						}
					}

					if (typeof setIsPersonalFormDirty === "function") {
						if (Object.keys(errors).length >= 1 && Object.keys(touched).length >= 1) {
							if (typeof setValidationError === "function") {
								setValidationError(true);
							}
						} else {
							if (typeof setValidationError === "function") {
								setValidationError(false);
							}
						}
						if (serverError && typeof setValidationError === "function") {
							setValidationError(true);
						}
					}

                    setDobCheck(!!errors['dob'] || (values['dob'] === "Invalid date"));
					return (<>

							<form className="mt20 floatLeft w100" onSubmit={handleSubmit} autoComplete="off">
								{
									!isAdmin(authUser) && !isAgent(authUser) &&
									<Typography variant="caption" className="mt15 mb15 colorRed">
										<sup>*</sup><strong>Please note</strong>: You must use your legal
										name that matches your drivers license.
									</Typography>
								}
								<FocusError offset={true} />
								<Grid container spacing={2}>
									{isFromClientDetail &&
										<Citizenship
											fieldObj={fieldObj}
											fieldObj4={fieldObj4}
											fieldObj14={fieldObj14}
											fieldObj7={fieldObj7}
											minAge={minAge}
											proofExpireRef={proofExpireRef}
											proofExpired={proofExpired}
											clientSigned={clientSigned}
											conditionalRequired={conditionalRequired}
											role={role}
											client={client}
											CommonField={CommonField}
											values={values}
											errors={errors}
											touched={touched}
											setFieldValue={setFieldValue}
											handleChange={handleChange}
											handleBlur={handleBlur}
											setAnticipatedAge={setAnticipatedAge}
                                            setNonUSPopUp={setNonUSPopUp}
                                            accountActions={accountActions}
										/>
									}

                                    {
                                            nonUSPopUp &&
                                            <NonUSPopUp
                                                    nonUSPopUp={nonUSPopUp}
                                                    setNonUSPopUp={setNonUSPopUp}
                                            />
                                    }

									{fieldObj1.map((field, index) => {
										return (
											<Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
												<div className="mt20">
													{
														CommonField(
															field,
															{
																values,
																errors,
																touched,
																handleChange,
																handleBlur,
																setFieldValue,
															},
														)
													}
												</div>
											</Grid>
										);
									})
									}

									{isFromClientDetail && !values["usCitizen"] &&
										fieldObj8.map((field, index) => {
											return (
												<Grid item xs={12} md={12} xl={6}
													  key={index + field["name"]}>
													<>
														{
															CommonField(
																field,
																{
																	values,
																	errors,
																	touched,
																	handleChange,
																	handleBlur,
																	setFieldValue,
																},
															)
														}
													</>
												</Grid>
											);
										})

									}

									{!isFromClientDetail &&
										<Citizenship
											fieldObj={fieldObj}
											fieldObj4={fieldObj4}
											fieldObj7={fieldObj7}
											fieldObj14={fieldObj14}
											minAge={minAge}
											proofExpireRef={proofExpireRef}
											proofExpired={proofExpired}
											clientSigned={clientSigned}
											conditionalRequired={conditionalRequired}
											role={role}
											client={client}
											CommonField={CommonField}
											values={values}
											errors={errors}
											touched={touched}
                                            isFromClientDetail={isFromClientDetail}
											setFieldValue={setFieldValue}
											handleChange={handleChange}
											handleBlur={handleBlur}
											setAnticipatedAge={setAnticipatedAge}
                                            setNonUSPopUp={setNonUSPopUp}
                                            accountActions={accountActions}
										/>
									}

								</Grid>

								{!values["usCitizen"] &&
									<Grid container spacing={2} className={"mt30"}>
										{!isFromClientDetail && fieldObj8.map((field, index) => {
											return (
												<Grid item xs={12} md={12} xl={6}
													  key={index + field["name"]}>
													<>
														{
															CommonField(
																field,
																{
																	values,
																	errors,
																	touched,
																	handleChange,
																	handleBlur,
																	setFieldValue,
																},
															)
														}
													</>
												</Grid>
											);
										})
										}

										{fieldObj9.map((field: any, index) => {
											return (
												<Grid item xs={12} md={12} key={index + field["name"]}>
													<Typography variant="body1"
																className="floatLeft mt20 mb0">
														{field.label}
													</Typography>
                                                    <Typography variant="caption"
																className="floatLeft mt0 mb10 w100 textRed">
														{field.subLabel}
													</Typography>
													<RadioGroup
														id={field.name}
														className="mb0 checkGroup checkGroupEnrollment"
														name={field.name}
														onChange={ async (e) => {
															const selectedValue = e.target.value;
                                                            const prevValue = values[field.name]; // previous immigration status

                                                            setFieldValue(field.name, selectedValue);

                                                            // always reset unrelated fields
                                                            setFieldValue("immigrationStatusOther", "");
                                                            setFieldValue("typeOfVisaHeld", "");
                                                            setFieldValue("typeOfVisaPlanHeld", "");

                                                            // only reset expiry fields if switching between PR ↔ VISA_PLAN
                                                            if (prevValue !== selectedValue) {
                                                                if (selectedValue === "PR") {
                                                                    // switched from VISA → PR
                                                                    setFieldValue("visaExpiryMonth", "");
                                                                    setFieldValue("visaExpiryYear", "");
                                                                } else if (selectedValue === "VISA_PLAN") {
                                                                    // switched from PR → VISA
                                                                    setFieldValue("greenCardExpiryMonth", "");
                                                                    setFieldValue("greenCardExpiryYear", "");
                                                                    setFieldValue("greenCardNo", "");
                                                                } else {
                                                                    // switching to something else → clear all expiry
                                                                    setFieldValue("greenCardExpiryMonth", "");
                                                                    setFieldValue("greenCardExpiryYear", "");
                                                                    setFieldValue("visaExpiryMonth", "");
                                                                    setFieldValue("visaExpiryYear", "");
                                                                    setFieldValue("greenCardNo", "");
                                                                }
                                                            }
                                                            let payload: any = {};
                                                            payload[field.name] = e.target.value;
                                                            await accountActions.updateUserBasicDetails(payload, (clientPolicy && clientPolicy.id) || 0, "");
														}}
														value={values[field.name]}
													>
														<Grid container spacing={2}>
                                                                                {field.options.map((option: any, idx: number) => (
                                                                                        <Grid item xs={12}>
                                                                                        <Grid container spacing={2} key={idx + option.name}>
                                                                                            <Grid item xs={12} md={8} className={classes.radioGroup}>
                                                                                                <div className="floatLeft w100">
                                                                                                <FormControlLabel
                                                                                                        className="mb0"
                                                                                                        disabled={!!clientSigned}
                                                                                                        value={option.value}
                                                                                                        control={
                                                                                                            <Radio
                                                                                                                    className="mb15 f18"
                                                                                                                    color="primary" />}
                                                                                                        label={option.label} />
                                                                                                </div>
                                                                                                {option.textField &&
                                                                                                        <Grid container>
                                                                                                            <Grid item
                                                                                                                  xs={12}
                                                                                                                  md={option.value === "1" || option.value === "OTHER" ? 12 : 6}
                                                                                                                  className="mt15">
                                                                                                                {
                                                                                                                    CommonField(
                                                                                                                            option.textField,
                                                                                                                            {
                                                                                                                                values,
                                                                                                                                errors,
                                                                                                                                touched,
                                                                                                                                handleChange,
                                                                                                                                handleBlur,
                                                                                                                                setFieldValue,
                                                                                                                            },
                                                                                                                    )
                                                                                                                }
                                                                                                            </Grid>
                                                                                                        </Grid>
                                                                                                }
                                                                                            </Grid>
                                                                                                <Grid item xs={12} md={4}>
                                                                                                    {(option.value === "PR" || option.value === "VISA_PLAN") && (
                                                                                                            <GreenCardAndVisaExpiry type={option.value}/>
                                                                                                    )}
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                ))}

                                                                                {touched[field.name] && errors[field.name] && (
                                                                                        <ErrorCommon errors={errors}
                                                                                                     name={field.name}
                                                                                                     touched={touched}/>
                                                                                )}
                                                                            </Grid>
													</RadioGroup>
												</Grid>
											);
										})
										}

									</Grid>
								}

								<span className="hLine mt30" />
								<Typography variant="h6" className="fontBold w100">Home Address</Typography>
								<Grid container spacing={2}>
									{fieldObj2.map((field, index) => {
										return (
											<Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
												<div className="mt20">
													{
														CommonField(
															field,
															{
																values,
																errors,
																touched,
																handleChange,
																handleBlur,
																setFieldValue,
															},
														)
													}
												</div>
											</Grid>
										);
									})
									}
                                    {
                                        documentDetailsDiscrepancyQuestions.map((field) =>{
                                                const { subfield, options, helperText, ...buttonProps } = field;
                                                return (
                                                        <Grid item xs={12} md={12} xl={12} className="floatLeft w100">
                                                            <Typography variant="caption" className="floatLeft mt20">
                                                                <Label label={buttonProps.label}
                                                                       required={conditionalRequired} />
                                                            </Typography>
                                                            <ToggleButtonGroup
                                                                    className="toggleButtonGroup mb10" size="large"
                                                                    value={values[buttonProps.name]} exclusive
                                                                    id={buttonProps.name}
                                                                    {...buttonProps}
                                                            >
                                                                {
                                                                    options.map((option: any) => (
                                                                            <ToggleButton value={option.value}
                                                                                          disabled={!!clientSigned}
                                                                                          className={option.active ? "active" : ""} {...option}>
                                                                                {option.label}
                                                                            </ToggleButton>
                                                                    ))
                                                                }
                                                            </ToggleButtonGroup>
                                                            {
                                                                helperText
                                                            }
                                                            {subfield.show && <Grid item xs={12} md={12} className="mt15">
                                                                <TextFieldCommon
                                                                        {...subfield}
                                                                        values={values}
                                                                        onChange={handleChange}
                                                                        InputLabelProps={{
                                                                            shrink: values && values[subfield.name],
                                                                        }}
                                                                />
                                                                <ErrorCommon errors={errors} name={subfield.name}
                                                                             touched={touched} />
                                                            </Grid>}
                                                        </Grid>
                                                )
                                        })
                                    }
								</Grid>
								<span className="hLine" />
								<Typography variant="h6"
											className="w100 mb20">{!isFromClientDetail && "Basic "} Income
									Details</Typography>
								<Grid container spacing={2}>
                                    <Grid item xs={12} md={12} xl={12}>
                                        <PersonalIncomeDetailsContent clientSigned={clientSigned} values={values}
                                                                      conditionalRequired={conditionalRequired}
                                                                      touched={touched} errors={errors}
                                                                      classes={classes} CommonField={CommonField}
                                                                      handleChange={handleChange}
                                                                      handleBlur={handleBlur}
                                                                      setFieldValue={setFieldValue}
                                                                      setIsMarried={setIsMarried}
                                                                      sendSaveRequest={sendSaveRequest}
                                        />
                                    </Grid>

                                    {
										    isGWTGenV2 &&
                                            <Grid container spacing={2} className="mb15 mt10">
                                                <Grid item xs={12} md={12} className={classes.radioGroup}>
                                                    <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                        className="pt0 pl15 pb0"
                                                                        checked={incomeEarner}
                                                                        onChange={(e) => {
                                                                            setIncomeEarner(e.target.checked);
                                                                            handleChange(e);
                                                                            if (typeof sendSaveRequest === "function") {
                                                                                sendSaveRequest(Math.random());
                                                                            }
                                                                        }}
                                                                        name="qualifiedIncomeEarner"
                                                                        disabled={true}
                                                                        color="primary"
                                                                />
                                                            }
                                                            label="I'm not the qualifying income earner for this product"
                                                    />

                                                    {
                                                            incomeEarner &&
                                                            <Grid container spacing={2} className={classes.hide}>
                                                                <Grid item xs={12} md={6}
                                                                      className={classes.radioGroup}>
                                                                    <ParentsAreIncomeEarner
                                                                            conditionalRequired={conditionalRequired}
                                                                            values={values}
                                                                            touched={touched}
                                                                            errors={errors}
                                                                            classes={classes}
                                                                            setFieldValue={setFieldValue}
                                                                            disabled={disabled}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                    }

                                    {!(isCorporation) &&
										<Grid item xs={12} md={12} xl={12} >
											<CurrentEmployeeRadio
												classes={classes}
												clientSigned={clientSigned}
												conditionalRequired={conditionalRequired}
												isAllianzLife={isAllianzLife}
												isParentEarner={isParentEarner}
												sendSaveRequest={sendSaveRequest}
												setCurrentlyEmployed={setCurrentlyEmployed}
												setFieldValue={setFieldValue}
												setFullTimeEmployee={setFullTimeEmployee}
												setFullTimeSelected={setFullTimeSelected}
												setIsEmployed={setIsEmployed}
												setIsParentEarner={setIsParentEarner}
												setSelfEmployed={setSelfEmployed}
												touched={touched} errors={errors}
												values={values}
                                                isGWTGenV2={isGWTGenV2}
												greenCardexpiryFieldObj={greenCardExpiryFieldObj}
                                                visaExpiryFieldObj={visaExpiryFieldObj}
											/>

										</Grid>
									}

									{isCorporation && //!(strategySlug === "cashstream") &&
										<Grid item xs={12} md={12} xl={12}>
											<Typography variant="caption"
														className="floatLeft textBlueDark mt20 mb15"> <Label
												label={"Are you a full time employee?"}
												required={conditionalRequired} /> </Typography>

											<RadioGroup
												className="mb0 checkGroup checkGroupEnrollment"
												name={"fullTimeEmployee"}
												onChange={(e) => {
													setFieldValue("fullTimeEmployee", Number(e.target.value));
													setFullTimeEmployee(Number(e.target.value));
												}}
												value={fullTimeEmployee ? fullTimeEmployee : values["fullTimeEmployee"]}
												style={{ display: "inline" }}
											>
												<Grid container spacing={2}>
													{[
														{
															label: "Yes",
															value: 1,
														},
														{
															label: "No",
															value: 0,
														},
													].map((option: any, idx: number) => (
														<Grid
															key={idx}
															sm={4}
															md={2}
															className={classes.radioGroup}>
															<FormControlLabel
																className="mb0"
																disabled={!!clientSigned}
																value={option.value}
																control={
																	<Radio
																		className="mb0 ml15"
																		color="primary" />}
																label={option.label} />
														</Grid>

													))}
												</Grid>
											</RadioGroup>
											{touched["fullTimeEmployee"] && errors["fullTimeEmployee"] && (
												<ErrorCommon errors={errors}
															 name={"fullTimeEmployee"}
															 touched={touched} />
											)}

										</Grid>
									}

                                    {
                                            isGWTGenV2 && values["currentlyEmployed"] !== "" &&
                                            <Grid item xs={12} md={12}>
                                                <Typography variant="caption" className="floatLeft mt20 mb0">
                                                    <Label label={"If you are currently employed, please fill out the following fields if applicable."} />
                                                </Typography>
                                            </Grid>
                                    }

                                    { fieldObj3.map((field, index) => {

										if (
											(field["name"] === "annualIncome") ||
											field["name"] === "annualIncome1" ||
											field["name"] === "annualIncome2"
										) {
											return null;
										}
										if (fullTimeSelected && (field["name"] === "annualIncome1" || field["name"] === "annualIncome2")) {
											return null;
										}

										if ((!values["fullTimeEmployee"]) &&
											(
												field["name"] === "employer" ||
												field["name"] === "employedTime" ||
												field["name"] === "annualIncome" ||
												field["name"] === "annualIncome1" ||
												field["name"] === "annualIncome2" ||
												field["name"] === "netWorth" ||
												field["name"] === "occupation" ||
												field["name"] === "industryId" ||
												field["name"] === "otherIndustry" ||
												field["name"] === "occupationId" ||
												field["name"] === "otherOccupation" ||
												field["name"] === "occupationDetail" ||
                                                field["name"] === "employerAddress"

											)
										) {
											return null;
										} else if (values["industryId"] === otherIndustryId && field["name"] === "occupationId") {
											return null;
										} else if (values["industryId"] !== otherIndustryId && (field["name"] === "otherIndustry" ||
											field["name"] === "occupation" || field["name"] === "otherOccupation")) {
											return null;
                                        } else if (values["currentlyEmployed"] === OTHER_VALUE) {
                                            return null;
										} else {
											return (
												<>
													<Grid item xs={12} md={6} xl={6}
														  key={index + field["name"]}>
														<div className="">
															{
																CommonField(
																	field,
																	{
																		values,
																		errors,
																		touched,
																		handleChange,
																		handleBlur,
																		setFieldValue,
																	},
																)
															}
														</div>
													</Grid>
												</>

											);
										}

									})
									}

                                    {
										basicInfoQuestions().map((fieldVal: any) => {
											return (
												radioToggleButtonGroup(
                                                        fieldVal.name,
                                                        values,
                                                        setFieldValue,
                                                        fieldVal.heading,
                                                        fieldVal.subHeading,
														fieldVal.subField,
                                                        fieldVal.onSelectChange,
                                                )
											);
										})
									}


                                    {!isCorporation && <>
                                        <IndividualIncome conditionalRequired={conditionalRequired}
                                                          CommonField={CommonField}
														  financiallyDependent={financiallyDependent}
														  currentlyEmployed={currentlyEmployed}
														  isGWTGenV2={isGWTGenV2}
                                        />
                                        {
                                            <HouseHoldIncome CommonField={CommonField}
                                                             handleChange={handleChange}
                                                             handleBlur={handleBlur}
                                                             setFieldValue={setFieldValue}
                                                             touched={touched} errors={errors}
                                                             values={values}
															 isGWTGenV2={isGWTGenV2}
															 financiallyDependent={financiallyDependent}
															 currentlyEmployed={currentlyEmployed}
                                            />
                                        }
                                        </>
                                    }
								</Grid>


								{(role === 1 || role === 2 || role === 4) &&
									<>
										<span className="hLine" />
										<Typography variant="h6" className="w100 mb20">Contribution
											Amount</Typography>
										<Grid container spacing={2}>
											{fieldObj6.map((field, index) => {
												if (props.clientDetail && (props.clientDetail.role === 5 || (props.clientDetail.role === 6 && numeral(props.clientDetail.clientPolicies && props.clientDetail.clientPolicies.employerContribution).value() < 1)) && field.name === "employerContribution") {
													return <React.Fragment> </React.Fragment>;
												}
												if (!showClientContribution && field["name"] === "contributionAmount") {
													return <React.Fragment> </React.Fragment>;
												}
												if (!showEmployerContribution && field["name"] === "employerContribution") {
													return <React.Fragment> </React.Fragment>;
												}
												return (<><Grid item xs={12} md={6} xl={4}
																key={index + field["name"]}>
														<div className="mt20 customFields">
															{
																CommonField(
																	field,
																	{
																		values,
																		errors,
																		touched,
																		handleChange,
																		handleBlur,
																		setFieldValue,
																	},
																)
															}
														</div>
														{field["name"] == "contributionAmount" && numeral(minVal).value() > 0 &&
															<span className="f12 textLight" style={{
																display: "flex",
																alignItems: "center",
															}}>
                                                                     <NumberFormat
																		 value={minVal}
																		 displayType={"text"}
																		 thousandSeparator={true} prefix={"$"}
																		 renderText={value =>
																			 <Box component="span">{value} </Box>}
																	 />
                                                                      minimum contribution (includes trust fees)
                                                                      <Tooltip arrow
																			   title={
																				   <React.Fragment>
																					   <Typography
																						   variant="caption"
																						   className="mb0">Annual
																						   contribution
																						   includes a <span
																							   className="textHighLight">{trustFeeText(client)}</span> trust
																						   fee
																						   per year
																						   for
																						   5
																						   years. Trust pays the life
																						   insurance premiums.
																						   Minimum
																						   contribution
																						   is <span
																							   className="textHighLight">
                                                                                               <NumberFormat
																								   value={minVal}
																								   displayType={"text"}
																								   thousandSeparator={true}
																								   prefix={"$"}
																								   renderText={value =>
																									   <Box
																										   component="span">{value} </Box>}
																							   /></span> with
																						   trust
																						   fees.</Typography>
																				   </React.Fragment>
																			   }
																	  >
                                                                        <IconButton aria-label="Info" color="primary">
                                                                            <InfoIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </span>
														}
													</Grid>
													</>
												);
											})
											}
										</Grid>
									</>
								}

								{isFromClientDetail && isNationalLife && <></>
								}
                                {(role === 1 || role === 2 || role === 4) ?
                                        <div style={{
                                            display: "none",
                                        }}><Button type="button" className={"detailPageSubmitBtn"} disabled={!dirty || isSubmitting}
                                                   ref={personalDetailSubmit} onClick={(e)=>{
                                            touchedState = {...touched}
                                                       setTouchedCustom(touchedState)
                                                handleSubmit()
                                        }}></Button></div> :
                                        <Button
                                                variant="contained"
                                                color="primary"
                                                className="floatRight mb30"
                                                disabled={(!!(clientSigned || proofExpired || dobCheck))}
                                                onClick={async () => {
                                                    setSubmitting(true);

                                                    const errors = await validateForm();
													if (Object.keys(errors).length === 0) {
                                                        saveMe && await saveMe(values)
                                                        await accountActions.getProfileDetails();
                                                        SetOpenPersonalDialog(true);
                                                    } else {
                                                        setTouched(errors as any);
                                                        setSubmitting(false);
                                                    }
                                                }}
                                        >
                                            Continue
                                        </Button>
                            }
                                {openPersonalDialog &&
                                        <PersonalDetailsDialog openPersonalDialog={openPersonalDialog}
                                                               SetOpenPersonalDialog={(flag: boolean) => SetOpenPersonalDialog(flag)}
                                                               contributionAmount={contributionAmount}
                                                               setBasicInfoStep={setBasicInfoStep} />
                                }

							</form>
						</>
					);
				}}
			</Formik>
		</>
	);
}

export default PersonalDetailFormikContent;